$(document).ready(function () {

    /**
    * TCR Module implementation
    */
    if (tcr_enable == true) {
        var tcr = document.createElement('script');
        tcr.src =  tcr_src;
        document.body.appendChild(tcr);
   
        let results = {};
        let value, key;
        let objectStructure = null;
        let index = 0;
        function createObj(obj) {
            key = obj.closest('.box').find('h2').data('title');
            value = obj.closest('li').find('input').val();
            if (objectStructure == null) {
                results[key] = value;

            } else if (obj.closest('.box').hasClass('three')) {
                if (typeof results[key] === 'object') {
                    results[key][index++] = value;

                } else {
                    results[key] = {};
                    results[key][index++] = value;
                }

            } else {
                results[key] = value;
            }

            objectStructure = results;

            // console.log(objectStructure);

            funnelEventEmitter('surveyResults', objectStructure);
        }

        $('label').on('click', function () {
            createObj($(this));
        })
    }
    
    function pagination() {
        const box = $('.box');
        const surveyForm = $('#surveyForm');
        
        $('.nextStep').addClass('hidden');
        
        $('label').on('click', function () {
            const boxes = $('.boxes');
            let proceedBtn = $(this).closest('.box').find('[data-proceed-step]');

            if ($(this).closest('.answers').attr('data-answer') == 'checkbox') {
                $(this).parent().toggleClass('checked');
                proceedBtn.removeClass('hidden').addClass('show');
            } else {
                $('.answers li').removeClass('checked');
                $(this).parent().addClass('checked');
            }

            if ($(this).closest('.answers').attr('data-answer') == 'radio') {
                if (surveyForm.hasClass('one')) {
                    surveyForm.removeClass('one').addClass('two');

                } else if (surveyForm.hasClass('two')) {
                    surveyForm.removeClass('two').addClass('three');
                }
            }
        });

        $('[data-proceed-step]').on('click', function () {
            if (surveyForm.hasClass('one')) {
                surveyForm.removeClass('one').addClass('two');

            } else if (surveyForm.hasClass('two')) {
                surveyForm.removeClass('two').addClass('three');
            }

            $('[data-proceed-step]').removeClass('show').addClass('hidden');
        })

        $('.box.three label').on('click', function () {
            $('.nextStep').removeClass('hidden').addClass('show');
            $('.survey.three .box').addClass('clicked');
            $('.skip').addClass('clicked');
        })
    }    

    pagination();

    //- Set current Year to footer Copyright
    if ($('#year').length) {
        let thisDate = new Date();
        $('#year').html(thisDate.getFullYear());
    }
});
